import { ScrollArea } from "@/components/ui/scroll-area";
import Typography from "@/components/ui/typography";

import { Thread } from "../types/thread";
import { ThreadItem } from "./ThreadItem";

interface ThreadsListProps {
  threads: Thread[];
  activeThreadId: string | null;
  onThreadSelect: (threadId: string) => void;
  onThreadDelete: (threadId: string) => void;
  isLoading?: boolean;
}

export const ThreadsList = ({
  threads,
  activeThreadId,
  onThreadSelect,
  onThreadDelete,
  isLoading = false,
}: ThreadsListProps) => {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-8">
        <Typography size="b2" className="text-sds-neutral-60">
          Loading chats...
        </Typography>
      </div>
    );
  }

  if (threads.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-8 px-4">
        <Typography size="b2" className="text-sds-neutral-60 text-center">
          No chats yet
        </Typography>
      </div>
    );
  }

  return (
    <ScrollArea className="h-full w-full [&_[data-radix-scroll-area-viewport]>div]:!block [&_[data-radix-scroll-area-viewport]>div]:!w-full">
      <div className="space-y-1 px-2 w-full">
        {threads.map((thread) => (
          <ThreadItem
            key={thread.thread_id}
            thread={thread}
            isActive={thread.thread_id === activeThreadId}
            onClick={() => onThreadSelect(thread.thread_id)}
            onDelete={onThreadDelete}
          />
        ))}
      </div>
    </ScrollArea>
  );
};
